/* split-view.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import React from "react";
import theme from "../theme";
var _18 = "._p12f1mu9{max-width:var(--_1p7w3p2)}";
var _17 = "._1ul9fx7m{min-width:var(--_74ww00)}";
var _16 = "._19bvidpf{padding-left:0}";
var _15 = "._n3tdidpf{padding-bottom:0}";
var _14 = "._u5f3idpf{padding-right:0}";
var _13 = "._ca0qidpf{padding-top:0}";
var _12 = "._16jlkb7n{flex-grow:1}";
var _11 = "._1kl79cqg{border-left:var(--_7sctaf)}";
var _10 = "._19bvf6fq{padding-left:18px}";
var _9 = "._n3tdf6fq{padding-bottom:18px}";
var _8 = "._u5f3f6fq{padding-right:18px}";
var _7 = "._ca0q7vkz{padding-top:1pc}";
var _6 = "._1kl7glyw{border-left:none}";
var _5 = "._18m915zi{overflow-y:scroll}";
var _4 = "._1reo15zi{overflow-x:scroll}";
var _3 = "._vchhusvi{box-sizing:border-box}";
var _2 = "._4t3i1osq{height:100%}";
var _ = "._1e0c1txw{display:flex}";
export var SplitView = function SplitView(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement("div", {
    "data-test-id": testId,
    className: ax(["_1e0c1txw _4t3i1osq"])
  }, children));
};
var splitViewColStyles = null;
var splitViewColGrowStyles = null;
var splitViewColSepStyles = null;
var splitViewColNoPaddingStyles = null;
export var SplitViewCol = function SplitViewCol(_ref2) {
  var children = _ref2.children,
    sep = _ref2.sep,
    grow = _ref2.grow,
    noPaddings = _ref2.noPaddings,
    minWidth = _ref2.minWidth,
    maxWidth = _ref2.maxWidth;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _2, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_vchhusvi _4t3i1osq _1reo15zi _18m915zi _1kl7glyw _ca0q7vkz _u5f3f6fq _n3tdf6fq _19bvf6fq", sep && "_1kl79cqg", grow && "_16jlkb7n", noPaddings && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf", "_1ul9fx7m _p12f1mu9"]),
    style: {
      "--_7sctaf": ix("1px solid " + theme.main20),
      "--_74ww00": ix(minWidth ? "".concat(minWidth, "px") : "none"),
      "--_1p7w3p2": ix(maxWidth ? "".concat(maxWidth, "px") : "none")
    }
  }, children));
};